import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 7.806 12.862',
}) => (
  <svg
    width={width}
    style={style}
    height="13"
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M35.093,44.588l-5.724,5.724a.707.707,0,0,1-1,0l-.668-.668a.707.707,0,0,1,0-1l4.537-4.558L27.7,39.531a.707.707,0,0,1,0-1l.668-.668a.707.707,0,0,1,1,0l5.724,5.724A.707.707,0,0,1,35.093,44.588Z"
          transform="translate(-27.494 -37.657)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
